"use client"

import { ChartBar } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChartBarIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChartBarIcon = component(Icon)({ as: ChartBar })
